// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {On_scroll_animation} from '../../shared/on_scroll_animation';
import {t_element_size} from '../../lib/screen_util';
import styles from './global_content.module.less';

type i_global_content = {
  title?: string;
  subtitle?: string;
  cls?: string;
}
export const Global_content = (props:i_global_content)=>{
    const {theme} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const key = 'hp.global_content';
    const anim = [{frames: {from: 60, to: 235}, direction: 1, loop: true}];
    const anim_size: t_element_size = {
        xs: [335, 218],
        sm: [335, 218],
        all: [544, 353],
    };
    return <div className={cn(theme.container, theme.block,
      styles.global_content, props.cls && props.cls)}>
      <On_scroll_animation animation={anim} cls={styles.animation}
        size={anim_size} src="animation/surfing.json" scroll_to_pos={0.5}/>
      <p className={cn(styles.caption, theme.u2)}>
        {props?.title || t(`${key}.caption`)}
      </p>
      <p className={cn(styles.text, theme.H4, theme.reg,
        props?.subtitle && theme.color_n700)}>
        {props?.subtitle || t(`${key}.text`)}
      </p>
    </div>;
};
